import React, { Component } from 'react';
import {
  Button, Card, CardBody, Col, Table, Badge, UncontrolledTooltip, FormGroup,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import swal from 'sweetalert';
import ReactPaginate from 'react-paginate';

import ProductModal from './ProductModal';
import Product from '../../../services/ProductService';
import global from '../../../global';

class ProductLists extends Component {
  constructor(props) {
    super(props);
    this.userData = JSON.parse(localStorage.getItem('userData'));
    this.state = {
      realList: [],
      list: [],
      modal: false,
      formData: {
        productName: '',
        user_id: this.userData.user_id,
      },
      title: 'ADD PRODUCT',
      errorMsg: '',
    };
    this.currDate = new Date();
    this.isLoading = false;
    this.toggleModal = this.toggleModal.bind(this);
    this.addToggle = this.addToggle.bind(this);
    this.addSubmitForm = this.addSubmitForm.bind(this);
    this.editToggle = this.editToggle.bind(this);
    this.editSubmitForm = this.editSubmitForm.bind(this);
    this.updateProductStatus = this.updateProductStatus.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.isLoading = true;
    if (navigator.onLine) {
      this.onLoadProducts();
    } else {
      console.log('no network');
    }
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  async onLoadProducts() {
    await Product.getProducts().then((response) => {
      const result = response;
      this.setState({ list: result, realList: result });
      this.handleClick();
      this.isLoading = false;
    }).catch((error) => {
      console.log('Error: ', error.message);
    });
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formData: { ...prevState.formData, [name]: value },
    }));
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ formData: { productName: '' } });
  };

  updateProductStatus = (e, id, status) => {
    e.preventDefault();
    const statusTxt = status === 1 ? 'activate' : status === 2 ? 'remove' : 'deactivate';
    swal({
      title: 'Confirmation',
      text: `Are you sure you want to ${statusTxt} this product?`,
      icon: 'warning',
      closeOnClickOutside: false,
      buttons: {
        yes: 'YES',
        no: 'NO',
      },
    }).then((name) => {
      name = name.toLowerCase();

      if (name === 'yes') {
        Product.updateProductStatus(id, status).then((result) => {
          if (result === true) {
            this.onLoadProducts();
            swal('', `Successfully ${statusTxt}d product!`, 'success');
          } else {
            swal('', 'Something went wrong!', 'error');
          }
        }).catch((error) => {
          console.log(error);
        });
      }
    });
  }

  addToggle() {
    this.toggleModal('Add');
    this.setState({
      formData: {
        productName: '',
        user_id: this.userData.user_id,
      },
    });
    this.handleSubmit = (e) => { this.addSubmitForm(e); };
  }

  async addSubmitForm(e) {
    e.preventDefault();
    const { formData } = this.state;
    if (formData.productName) {
      // insert product
      await Product.addProduct(formData).then((result) => {
        if (result.msg_resp === true) {
          this.onLoadProducts();
          this.setState({ errorMsg: '', modal: false });

          swal({
            title: 'New Product was added!',
            text: 'Would you like to add a new product?',
            icon: 'success',
            closeOnClickOutside: false,
            buttons: {
              no: 'NOPE',
              yes: 'ADD NEW',
            },
          }).then((name) => {
            name = name.toLowerCase();

            if (name === 'yes') {
              this.addToggle();
            }
          });
        } else {
          this.setState({ errorMsg: result.msg_resp });
        }
      }).catch((error) => {
        console.log(error);
      });
    } else {
      this.setState({ errorMsg: 'Required fields are empty.' });
    }
  }

  handleClick(event = '') {
    const selected = event !== '' ? event.selected + 1 : 1;
    const { realList } = this.state;

    const lastPost = selected * 10;
    const firstPost = lastPost - 10;

    const newList = realList.slice(firstPost, lastPost);
    this.setState({ list: newList });
 }

  editToggle(id) {
    this.toggleModal('Edit');
    this.setState({ errorMsg: '' });
    // get info
    Product.getProductInfo(id).then((result) => {
      if (result) {
        this.setState({
          formData: { productName: result.product_name },
        });
      }
    }).catch((error) => {
      console.log(error);
    });
    // submit form
    this.handleSubmit = (e) => { this.editSubmitForm(e, id); };
  }

  editSubmitForm(e, id) {
    e.preventDefault();
    const { formData } = this.state;
    formData.id = id;
    if (formData.productName) {
      Product.editProduct(formData).then((result) => {
        if (result === true) {
          const { list } = this.state;
          list.filter((listResp) => {
            if (listResp.product_id === id) {
              listResp.product_name = formData.productName;
            }
            return listResp;
          });
          this.setState({ list, modal: false });

          swal('', 'Successfully updated product name!', 'success');
        } else {
          this.setState({ errorMsg: result });
        }
      }).catch((error) => {
        console.log(error);
      });
    } else {
      this.setState({ errorMsg: 'Required fields are empty.' });
    }
  }

  toggleModal(text = '') {
    this.setState(prevState => ({ modal: !prevState.modal }));
    if (text) {
      this.setState({ title: text });
    }
  }

  render() {
    const {
      list, modal, formData, title, errorMsg, realList,
    } = this.state;
    const { statusType } = global;

    return (
      <Col md={12}>
        <ProductModal
          title={`${title} Product`}
          btn="Add Product"
          modal={modal}
          toggle={this.toggleModal}
          handleChange={this.handleChange}
          postValue={formData}
          handleSubmit={this.handleSubmit}
          errorMsg={errorMsg}
        />
        <Card className="panel panel--primary do_magic" id="product_page">
          <CardBody className="panel__body">
            <div className="panel__title bg_blue">
              <h5 className="bold-text">PRODUCTS</h5>

              <div className="panel__btns">
                <Button onClick={this.addToggle} className="rounded text-white" size="sm" outline><i className="fa fa-cart-plus m-r-4" /> <span>Add Product</span></Button>
              </div>
            </div>

            <div className="panel__content">
              <Table responsive striped className="doResTable">
                <thead>
                  <tr>
                    <th>Product Name</th>
                    <th>Date Added</th>
                    <th className="text-center">Status</th>
                    <th width="10%" className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    list !== false || list.length > 0 ? list.map((item, i) => {
                      item.status = parseInt(item.status, 10);
                      let statusColor = 'success';
                      let btnColor = 'danger';
                      let btnIcon = 'times';
                      let statusText = 'Deactivate';
                      if (item.status === 1) {
                        statusColor = 'danger';
                        btnColor = 'success';
                        btnIcon = 'check';
                        statusText = 'Activate';
                      }

                      return (
                        <tr key={parseInt(i.toString(), 10)}>
                          <td>{item.product_name}</td>
                          <td>{item.date_added}</td>
                          <td className="text-center" width="130px"><Badge color={statusColor}>{statusType[item.status]}</Badge></td>
                          <td className="text-center ab">
                            {
                              /* Edit */
                              item.status === 0 && (
                                <>
                                  <Button color="primary" className="btn-xs" onClick={() => this.editToggle(item.product_id)} id={`prodeditbtn${i + 1}`} outline><span className="lnr lnr-pencil" /></Button>
                                  <UncontrolledTooltip placement="bottom" target={`prodeditbtn${i + 1}`}>Edit</UncontrolledTooltip>
                                </>
                              )
                            }
                            {/* Activate / Deactivate */}
                            <Button color={btnColor} className="btn-xs" onClick={e => this.updateProductStatus(e, item.product_id, item.status)} id={`statusbtn${i + 1}`} outline><span className={`fa fa-${btnIcon}`} /></Button>
                            <UncontrolledTooltip placement="bottom" target={`statusbtn${i + 1}`}>{statusText}</UncontrolledTooltip>

                            {/* Permanent Delete */}
                            <Button color="danger" className="btn-xs" onClick={e => this.updateProductStatus(e, item.product_id, 2)} id={`trashbtn${i + 1}`} outline><span className="fa fa-trash" /></Button>
                            <UncontrolledTooltip placement="bottom" target={`trashbtn${i + 1}`}>Permanent Delete</UncontrolledTooltip>
                          </td>
                        </tr>
                      );
                    }) : (
                      <tr className="text-center">
                        <td colSpan="5">No data available..</td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
              <FormGroup className={list === false || (realList.length / 10) <= 1 ? 'display-none' : ''}>
                <ReactPaginate
                    previousLabel="<<"
                    nextLabel=">>"
                    breakLabel="..."
                    breakClassName="break-me"
                    pageCount={realList.length / 10}
                    onPageChange={this.handleClick}
                    marginPagesDisplayed={0}
                    pageRangeDisplayed={2}
                    containerClassName="list-pagination"
                    activeClassName="active"
                />
              </FormGroup>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default withTranslation('common')(ProductLists);
